
// 保障权益
const bzqy = [{
    title: '意外身故及伤残',
    planA: '300,000',
    planB: '500,000',
    planC: '1,000,000'
}, {
    title: '突发急性病身故保障',
    planA: '30,000',
    planB: '50,000',
    planC: '100,000'
}, {
    title: '公共交通工具意外伤害',
    planA: '',
    planB: '300,000',
    planC: '300,000'
}, {
    title: '医疗费用保险金 （含门诊和住院，含新冠保障） ',
    planA: '300,000',
    planB: '400,000',
    planC: '600,000'
}, {
    title: '意外住院津贴',
    planA: '',
    planB: '100元/天 (90日为限）',
    planC: '200元/天 (90日为限）'
}, {
    title: '旅行期间的非法拘禁及绑架',
    planA: '',
    planB: '150元/天 （30天为限）',
    planC: '300元/天  (30天为限)'
}, {
    title: '医疗运送和送返 （含新冠保障）',
    planA: '300,000',
    planB: '500,000',
    planC: '1,000,000'
}, {
    title: '亲属慰问探望',
    planA: '',
    planB: '单程经济舱机票',
    planC: '单程经济舱机票'
}, {
    title: '身故遗体送返 (丧葬费用限2万)',
    planA: '300,000',
    planB: '500,000',
    planC: '500,000'
}, {
    title: '行李丢失或损坏',
    planA: '',
    planB: '3,000 \n(单件物品赔付限额1,000元）',
    planC: '5,000 \n(单件物品赔付限额1,000元）'
}, {
    title: '行李延误',
    planA: '',
    planB: '1,500元(每8小时赔偿500元)',
    planC: '1,500元(每8小时赔偿500元)'
}, {
    title: '个人现金丢失',
    planA: '',
    planB: '1,500',
    planC: '2,000'
}, {
    title: '旅行证件丢失',
    planA: '',
    planB: '5,000',
    planC: '8,000'
}, {
    title: '航班延误',
    planA: '',
    planB: '500\n(每5小时延误赔付250元)',
    planC: '500\n(每5小时延误赔付250元)'
}, {
    title: '旅行缩短 （含新冠保障）',
    planA: '',
    planB: '',
    planC: '5,000'
}, {
    title: '旅行取消（含新冠保障）',
    planA: '',
    planB: '5,000',
    planC: '8,000'
}, {
    title: '个人第三者责任',
    planA: '',
    planB: '100,000',
    planC: '200,000'
}, {
    title: '家居保障',
    planA: '',
    planB: '',
    planC: '5,000'
}, {
    title: '信用卡盗刷 (不适用于未成年人) ',
    planA: '',
    planB: '10,000',
    planC: '10,000'
}, {
    title: '签证拒签',
    planA: '',
    planB: '700',
    planC: '700'
}, {
    title: '高风险运动',
    planA: '包含',
    planB: '包含',
    planC: '包含'
}, {
    title: '提供境外住院医疗直付服务',
    planA: '',
    planB: '包含',
    planC: '包含'
}, {
    title: '旅行目的地医疗机构推荐',
    planA: '',
    planB: '',
    planC: '包含'
}, {
    title: '旅行目的地法律援助推荐',
    planA: '',
    planB: '',
    planC: '包含'
}, {
    title: '旅行目的地紧急信息和文件的传递 ',
    planA: '',
    planB: '',
    planC: '包含'
}, {
    title: '在线翻译服务',
    planA: '',
    planB: '',
    planC: '包含'
},];
const bzqyEn = [{
    title: 'Accidental Death & Disablement',
    planA: '300,000',
    planB: '500,000',
    planC: '1,000,000'
}, {
    title: 'Death due to Acute Disease',
    planA: '30,000',
    planB: '50,000',
    planC: '100,000'
}, {
    title: 'Public Tansportation Accidental death & disablement',
    planA: '',
    planB: '300,000',
    planC: '300,000'
}, {
    title: 'Accident & Acute Disease Medical Expenses( Cov-19 Covered )',
    planA: '300,000',
    planB: '400,000',
    planC: '600,000'
}, {
    title: 'Accidental Hospital Income ',
    planA: '',
    planB: 'RMB 100 per day（MAX 90 Days）',
    planC: 'RMB 200 per day（MAX 90 Days）'
}, {
    title: 'Allowance for Kidnap and Wrongful Detention',
    planA: '',
    planB: 'RMB150 per day（MAX 30 Days）',
    planC: 'RMB300 per day（MAX 30 Days）'
}, {
    title: 'Medical Evacuation and Repatriation( Cov-19 Covered )',
    planA: '300,000',
    planB: '500,000',
    planC: '1,000,000'
}, {
    title: 'relative visit',
    planA: '',
    planB: 'One-Way Air ticket of Economic Class',
    planC: 'One-Way Air ticket of Economic Class'
}, {
    title: 'Death Remain Repatriation',
    planA: '300,000',
    planB: '500,000',
    planC: '500,000'
}, {
    title: 'Baggage Lost or Destroy',
    planA: '',
    planB: '（Each baggage limitation:1,000 RMB）',
    planC: '（Each baggage limitation:1,000 RMB）'
}, {
    title: 'Baggage Delay',
    planA: '',
    planB: '(RMB 500 for every 8 hours)',
    planC: '(RMB 500 for every 8 hours)'
}, {
    title: 'cash loss',
    planA: '',
    planB: '1,500',
    planC: '2,000'
}, {
    title: 'Loss of Travel Documents',
    planA: '',
    planB: '5,000',
    planC: '8,000'
}, {
    title: ' Flight delay ',
    planA: '',
    planB: '(RMB 250 for Each 5 Hours）',
    planC: '(RMB 250 for Each 5 Hours）'
}, {
    title: 'Trip Shortening( Cov-19 Covered )',
    planA: '',
    planB: '',
    planC: '5,000'
}, {
    title: 'Trip Cancellation ( Cov-19 Covered )',
    planA: '',
    planB: '5,000',
    planC: '8,000'
}, {
    title: 'Personal Liability ',
    planA: '',
    planB: '100,000',
    planC: '200,000'
}, {
    title: 'house propety cover during trip ',
    planA: '',
    planB: '',
    planC: '5,000'
}, {
    title: 'Credit Card Fraudulent Charges(not applicable to Minor)',
    planA: '',
    planB: '10,000',
    planC: '10,000'
}, {
    title: 'Visa Refusal',
    planA: '',
    planB: '700',
    planC: '700'
}, {
    title: 'High risk sport ',
    planA: 'Yes',
    planB: 'Yes',
    planC: 'Yes'
}, {
    title: 'Medical expense paid in advance ',
    planA: '',
    planB: 'Yes',
    planC: 'Yes'
}, {
    title: 'trip destination medical insistution recommend ',
    planA: '',
    planB: '',
    planC: 'Yes'
}, {
    title: 'trip destination legal assistance recommend ',
    planA: '',
    planB: '',
    planC: 'Yes'
}, {
    title: 'trip destination information and document delivery ',
    planA: '',
    planB: '',
    planC: 'Yes'
}, {
    title: 'Online Translation',
    planA: '',
    planB: '',
    planC: 'Yes'
},];
const plan1 = [{
    min: 1,
    max: 3,
    value: 97
}, {
    min: 4,
    max: 5,
    value: 129
}, {
    min: 5,
    max: 7,
    value: 163,
}, {
    min: 8,
    max: 10,
    value: 215
}, {
    min: 11,
    max: 14,
    value: 297
}, {
    min: 15,
    max: 17,
    value: 327
}, {
    min: 18,
    max: 25,
    value: 432
}, {
    min: 26,
    max: 28,
    value: 523
}, {
    avg: 111,
    year: 2097
}];
const plan2 = [{
    min: 1,
    max: 3,
    value: 176
}, {
    min: 4,
    max: 5,
    value: 216
}, {
    min: 5,
    max: 7,
    value: 258,
}, {
    min: 8,
    max: 10,
    value: 326
}, {
    min: 11,
    max: 14,
    value: 433
}, {
    min: 15,
    max: 17,
    value: 473
}, {
    min: 18,
    max: 25,
    value: 607
}, {
    min: 26,
    max: 28,
    value: 726
}, {
    avg: 145,
    year: 2796
}];
const plan3 = [{
    min: 1,
    max: 3,
    value: 221
}, {
    min: 4,
    max: 5,
    value: 273
}, {
    min: 5,
    max: 7,
    value: 328,
}, {
    min: 8,
    max: 10,
    value: 418
}, {
    min: 11,
    max: 14,
    value: 563
}, {
    min: 15,
    max: 17,
    value: 613
}, {
    min: 18,
    max: 25,
    value: 790
}, {
    min: 26,
    max: 28,
    value: 947
}, {
    avg: 192,
    year: 3680
}];
const planPremiumTable = {
    1: plan1,
    2: plan2,
    3: plan3
}
const calcPremium = (plan, days) => {
    let sum = 0
    const plan1 = planPremiumTable[plan]
    if (days == 'year') {
        sum = plan1[plan1.length - 1].year
    } else if (days > 28) {
        let num = Math.floor(days / 7) + (days % 7 == 0 ? 0 : 1)
        sum = plan1[plan1.length - 2].value + plan1[plan1.length - 1].avg * (num - 4)
    } else {
        const item = plan1.filter(item => {
            return item.min <= days && days <= item.max
        })
        sum = item[0].value
    }
    console.log('计算保费 -> ', plan, days, sum, planPremiumTable, plan1)
    return sum.toFixed(2)
}
const premiumRules = [{
    days: '1-3',
    plan1: '97',
    plan2: '176',
    plan3: '221'
}, {
    days: '4-5',
    plan1: '129',
    plan2: '216',
    plan3: '273'
}, {
    days: '6-7',
    plan1: '163',
    plan2: '258',
    plan3: '328'
}, {
    days: '8—10',
    plan1: '215',
    plan2: '326',
    plan3: '418'
}, {
    days: '11-14',
    plan1: '297',
    plan2: '433',
    plan3: '563'
}, {
    days: '15-17',
    plan1: '327',
    plan2: '473',
    plan3: '613'
}, {
    days: '18-25',
    plan1: '432',
    plan2: '607',
    plan3: '790'
}, {
    days: '26-28',
    plan1: '523',
    plan2: '726',
    plan3: '947'
}, {
    days: '每增加一周',
    plan1: '111',
    plan2: '145',
    plan3: '192'
}, {
    days: '1年（每次旅行的保障期限最长为90天）',
    plan1: '2097',
    plan2: '2796',
    plan3: '3680'
}];
const premiumRulesEn = [{
    days: '1-3',
    plan1: '97',
    plan2: '176',
    plan3: '221'
}, {
    days: '4-5',
    plan1: '129',
    plan2: '216',
    plan3: '273'
}, {
    days: '6-7',
    plan1: '163',
    plan2: '258',
    plan3: '328'
}, {
    days: '8—10',
    plan1: '215',
    plan2: '326',
    plan3: '418'
}, {
    days: '11-14',
    plan1: '297',
    plan2: '433',
    plan3: '563'
}, {
    days: '15-17',
    plan1: '327',
    plan2: '473',
    plan3: '613'
}, {
    days: '18-25',
    plan1: '432',
    plan2: '607',
    plan3: '790'
}, {
    days: '26-28',
    plan1: '523',
    plan2: '726',
    plan3: '947'
}, {
    days: 'one week after 4 weeks',
    plan1: '111',
    plan2: '145',
    plan3: '192'
}, {
    days: '1 year with 90 days per trip max',
    plan1: '2097',
    plan2: '2796',
    plan3: '3680'
},]
const premiumColumns = [{
    title: '保险期间（天）',
    dataIndex: 'days',
    key: 'days'
}, {
    title: '保险计划',
    children: [{
        title: '经济计划',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: '升级计划',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: '白金计划',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}]
const premiumColumnsEn = [{
    title: 'Duration（day）',
    dataIndex: 'days',
    key: 'days'
}, {
    title: 'Insurance Plan',
    children: [{
        title: 'Economic Plan',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: 'Advance Plan',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: 'Pemium Plan',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}]
const planDays = ['1-3', '4-5', '6-7', '8-10', '11-14', '15-17', '18-25', '26-28'];
const columns = [
    {
        title: "中银申根计划保障",
        dataIndex: "title",
        key: "title",
    },
    {
        title: "经济计划",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "升级计划",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "白金计划",
        dataIndex: "planC",
        key: "planC",
    },
];
const columnsEn = [
    {
        title: "BOCI Schengen Travel Plan Insurance",
        dataIndex: "title",
        key: "title",
    },
    {
        title: "Economic Plan",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "Advance Plan",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "Premium Plan",
        dataIndex: "planC",
        key: "planC",
    },
];
const plans = ['中银申根计划保障(经济计划)', '中银申根计划保障(升级计划)', '中银申根计划保障(白金计划)',
    '中银申根计划保障(经济计划全年)', '中银申根计划保障(升级计划全年)', '中银申根计划保障(白金计划全年)'
];
const plansEn = ['BOCI Schengen Insurance Plan - Economic', 'BOCI Schengen Insurance Plan - Advance',
    'BOCI Schengen Insurance Plan - Pemium', 'BOCI Schengen Insurance Plan - Annual Economic',
    'BOCI Schengen Insurance Plan - Annual Advance', 'BOCI Schengen Insurance Plan - Annual Pemium'
];
export {
    plans,
    plansEn,
    columns,
    columnsEn,
    planDays,
    bzqy,
    bzqyEn,
    calcPremium,
    premiumRules,
    premiumRulesEn,
    premiumColumns,
    premiumColumnsEn,
}